<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('websiteAccessLogManage.queryCondition') }}</span>
            <el-button 
              style="float: right; padding: 3px 0" 
              type="text"
              @click="_moreCondition()"
            >
              {{ websiteAccessLogManageInfo.moreCondition ? $t('websiteAccessLogManage.hide') : $t('websiteAccessLogManage.more') }}
            </el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="websiteAccessLogManageInfo.conditions.logId"
                :placeholder="$t('websiteAccessLogManage.logIdPlaceholder')"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="websiteAccessLogManageInfo.conditions.ip"
                :placeholder="$t('websiteAccessLogManage.ipPlaceholder')"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="websiteAccessLogManageInfo.conditions.accessUrl"
                :placeholder="$t('websiteAccessLogManage.accessUrlPlaceholder')"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-button 
                type="primary" 
                @click="_queryWebsiteAccessLogMethod()"
                icon="el-icon-search"
              >
                {{ $t('websiteAccessLogManage.query') }}
              </el-button>
            </el-col>
          </el-row>
          <el-row v-if="websiteAccessLogManageInfo.moreCondition" :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="websiteAccessLogManageInfo.conditions.loginState"
                :placeholder="$t('websiteAccessLogManage.loginStatePlaceholder')"
                clearable
              />
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('websiteAccessLogManage.logInfo') }}</span>
          </div>
          <website-access-log-table 
            :websiteAccessLogs="websiteAccessLogManageInfo.websiteAccessLogs"
            :total="websiteAccessLogManageInfo.total"
            :page="websiteAccessLogManageInfo.conditions.page"
            @page-change="_listWebsiteAccessLogs"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listWebsiteAccessLog } from '@/api/platform/websiteAccessLogManage/websiteAccessLogApi'
import WebsiteAccessLogTable from '@/components/platform/websiteAccessLogManage/websiteAccessLogTable'

export default {
  name: 'WebsiteAccessLogManage',
  components: {
    WebsiteAccessLogTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      websiteAccessLogManageInfo: {
        websiteAccessLogs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          logId: '',
          ip: '',
          accessUrl: '',
          loginState: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listWebsiteAccessLogs(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    _listWebsiteAccessLogs(page, rows) {
      this.websiteAccessLogManageInfo.conditions.page = page
      this.websiteAccessLogManageInfo.conditions.row = rows
      
      listWebsiteAccessLog(this.websiteAccessLogManageInfo.conditions)
        .then(response => {
          this.websiteAccessLogManageInfo.total = response.total
          this.websiteAccessLogManageInfo.records = response.records
          this.websiteAccessLogManageInfo.websiteAccessLogs = response.data
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    _queryWebsiteAccessLogMethod() {
      this._listWebsiteAccessLogs(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _moreCondition() {
      this.websiteAccessLogManageInfo.moreCondition = !this.websiteAccessLogManageInfo.moreCondition
    }
  }
}
</script>

<style scoped>
.el-col {
  margin-bottom: 20px;
}
</style>